export default __webpack_public_path__ + "static/media/pexels-hemin-suthar-4727408.00aae7e2.jpg";